module.exports = __webpack_public_path__ + "static/media/Internet_Privacy_Policy_01-2015.652f619b.pdf";